import { formatShortcut } from 'automation-ui-canvas/components/flow-header/menu-bar/utils/formatShortcut';
import styled from 'styled-components';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledKeyboardKey = styled.div.withConfig({
  displayName: "EditorShortcutLabel__StyledKeyboardKey",
  componentId: "sc-1mtavcj-0"
})(["display:inline-block;border:", " solid ", ";border-radius:", ";padding:", ";margin:0 ", ";cursor:pointer;"], ({
  theme
}) => theme.borderWidth['100'], ({
  theme
}) => theme.color['border-core-default'], ({
  theme
}) => theme.borderRadius['200'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['50']);
const EditorShortcutLabel = ({
  shortcut,
  use = 'default'
}) => {
  const primaryShortcut = Array.isArray(shortcut) ? shortcut[0] : shortcut;
  const shortcutParts = formatShortcut(primaryShortcut);
  let shortcutText;
  if (use === 'table') {
    shortcutText = shortcutParts.map(({
      type,
      value,
      tooltip
    }) => {
      if (type === 'text') {
        return value;
      }
      const label = /*#__PURE__*/_jsx(StyledKeyboardKey, {
        children: value
      });
      return tooltip ? /*#__PURE__*/_jsx(UITooltip, {
        title: tooltip,
        children: label
      }) : label;
    });
  } else {
    shortcutText = shortcutParts.map(({
      value
    }) => value).join('');
  }
  return /*#__PURE__*/_jsx(View, {
    as: "span",
    marginInlineStart: "500",
    "data-test-id": "shortcut-label",
    children: shortcutText
  });
};
export default EditorShortcutLabel;